
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor5 as ObiResistor5Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-5.js';
 
 
 

 
 export const ObiResistor5 = createComponent({
   react: React,
   tagName: 'obi-resistor-5',
   elementClass: ObiResistor5Element,
   events: {
     
   }
  });
 
 